import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { handleUnauthorized } from './auth401.ts';
import { baseUrl, getConfig } from '../../../serverUrl.js';

/**
 * A drop-in replacement for fetchBaseQuery that:
 * 1. Injects the Authorization header automatically.
 * 2. Calls handleUnauthorized() and redirects to /login on any 401 response.
 *
 * Use this in any slice that uses RTK Query's built-in `query:` shorthand
 * (as opposed to a raw `fetch` inside `queryFn`).
 */
const rawBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    const ConfigData = getConfig();
    if (ConfigData?.headers) {
      Object.entries(ConfigData.headers).forEach(([key, value]) => {
        headers.set(key, value as string);
      });
    }
    return headers;
  },
});

export const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    handleUnauthorized();
  }

  return result;
};
